export enum ESpvStatus {
    pending = 'pending',
    trading = 'trading',
    suspended = 'suspended',
}
